import {FCWithHTMLAttributes} from "@/app/types/reactTypes";
import Subject from "@/app/util/Subject";
import clsMerge from "@/app/util/clsMerge";

export type UpperCatalogBackgroundProps = {
	subject: Subject;
};
const subjectBackgroundClasses: Record<Subject, string> = {
	[Subject.MATH]: "bg-navy-100",
	[Subject.LANGUAGE_ARTS]: "bg-orange-100",
	[Subject.SCIENCE]: "bg-[#D7E3B7]",
	[Subject.COMPUTER_SCIENCE]: "bg-gray-300",
};
const subjectBackgroundCircleClasses: Record<Subject, string> = {
	[Subject.MATH]: "bg-[#3075A566]",
	[Subject.LANGUAGE_ARTS]: "bg-[#a1442966]",
	[Subject.SCIENCE]: "bg-[#3f6d3766]",
	[Subject.COMPUTER_SCIENCE]: "bg-[#77767466]",
};
const UpperCatalogBackground: FCWithHTMLAttributes<
	UpperCatalogBackgroundProps
> = ({subject}) => {
	return (
		<div
			className={clsMerge(
				"relative h-[8.63rem] w-full overflow-hidden rounded-t-[2.5rem] md:rounded-[2.5rem] xl:h-[24.19rem]",
				subjectBackgroundClasses[subject]
			)}
		>
			<div
				className={clsMerge(
					"absolute left-2/4 top-[1.34rem] h-[43.75rem] w-[43.75rem] -translate-x-2/4 rounded-full xl:hidden",
					subjectBackgroundCircleClasses[subject]
				)}
			></div>
		</div>
	);
};

export default UpperCatalogBackground;
